module.exports = __webpack_public_path__ + "static/media/clm.961bab64.png";